module.exports = __webpack_public_path__ + "static/media/android@2x.79fb6fb3.png";